<template>
  <div>
    
    <div
      v-if="local_row"
      class="sendout-box"
    >
      <div class="sendout-header">
        <div class="sendout-title">
          <span>{{ $t('MEMBER_RENEW_CAMPAIGN.SCHEDULED_SENDOUTS.ITEM_TITLE') }}</span>
          <span v-if="local_row.id" class="id-pill">#{{ index+1 }}</span>
        </div>
        <div class="sendout-actions">
          <memlist-table-button
            @click="delete_row_clicked"
            svg="/assets/svg/trash2.svg"
            :tooltip="$t('COMMON.DELETE')"
          />
        </div>
      </div>

      <div class="sendout-content">
        <m-row>
          <m-col lg="6" md="12">
            <memlist-select-input2
              size="synced"
              layout="vertical"
              :title="$t('MEMBER_RENEW_CAMPAIGN.SCHEDULED_SENDOUTS.SENDOUT_METHOD')"
              :items="sendout_types"
              v-model="local_row.sendout_method"
              :state="field_state(local_row, 'type')"
              @input="type_updated"
            />
          </m-col>
          <m-col lg="6" md="12">
            <memlist-date-picker
              
              layout="vertical"
              :title="$t('MEMBER_RENEW_CAMPAIGN.SCHEDULED_SENDOUTS.DATE')"
              v-model="local_row.scheduled_at"
              :state="field_state(local_row, 'scheduled_at')"
              @input="scheduled_at_updated"
            />
          </m-col>
        </m-row>

        <m-row class="mt-2" v-if="show_channel_options">
          <m-col lg="6">
            <memlist-select-input2
              size="synced"
              layout="vertical"
              :title="$t('MEMBER_RENEW_CAMPAIGN.SCHEDULED_SENDOUTS.TEMPLATE')"
              :items="template_options"
              v-model="local_row.template_id"
              :state="field_state(local_row, 'template_id')"
              @input="template_id_updated"
            />
            
          </m-col>
          <m-col lg="6">
            <memlist-button style="margin-top: 20px;" variant="primary">{{ $t('MEMBER_RENEW_CAMPAIGN.SCHEDULED_SENDOUTS.VIEW_TEMPLATE') }}</memlist-button>
          </m-col>
        </m-row>
      </div>
    </div>

    
  </div>
</template>

<script>
import axios from 'axios'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { mapGetters } from 'vuex'
import { toasts } from '@/core/mixins/toastr-helper.mixin.js'


export default {
  name: 'RenewCampaignScheduledSendoutRow',
  mixins: [toasts],
  props: {
    index: { type: Number, default: 0 },
    row_id: { type: Number, default: null },
    campaign_id: { type: [Number, String], required: true },
    renew_settings: { type: Object, default: {} },
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      
      campaign: null,
      local_row: [],
      templates: [],
    }
  },
  computed: {
    sendout_types() {
      return [
        { text: this.$t('MEMBER_RENEW.SENDOUT_METHODS.EMAIL'), value: 'EMAIL' },
        { text: this.$t('MEMBER_RENEW.SENDOUT_METHODS.SMS'), value: 'SMS' },
        { text: this.$t('MEMBER_RENEW.SENDOUT_METHODS.POST'), value: 'POST' },
        { text: this.$t('MEMBER_RENEW.SENDOUT_METHODS.INVOICE'), value: 'INVOICE' },
        { text: this.$t('MEMBER_RENEW.SENDOUT_METHODS.CALL'), value: 'CALL' },
      ];
    },
    template_options() {
      return this.templates.filter(i => i.type === this.local_row.type).map(i => ({ text: i.name, value: i.template_id }));
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings']),
    
    show_channel_options() { return !!this.local_row.type },

  },
  validations () { return this.rules },
  watch: {
    row_id: {
      immediate: true,
      handler (val) {
        if (val) {
          this.fetch_sendout(val);
        }
        else {
          this.local_row = {
            sendout_method: 'EMAIL',
            template_id: this.renew_settings.email_template_id
          }
        }
      }
    }
  },
  methods: {
    template_id_updated() {
      this.update_row(this.local_row);
    },
    type_updated() {
      this.update_row(this.local_row);
    },
    scheduled_at_updated() {
      this.update_row(this.local_row);
    },
    
    async fetch_sendout(id) {
      const res = await axios.get(`/member_renew/campaign/schedule/sendout/${id}`);

      if (res.status === 200) {
        this.local_row = res.data;
      }
    },
    async fetch_template_options() {
      const res = await axios.get(`/template?company_id=${this.currentCompanyId}`);

      if (res.status === 200) {
        this.templates = res.data;
      }
    },

    field_state (row, field) {
      return null;
    },

    async update_row(item) {
      const res = await axios.put(`/member_renew/campaign/schedule/sendout/${item.id}`, item);

      if (res.status === 204) {
        console.log('ok');
        this.$nextTick(() => { this.v$ && this.v$.$touch() });
      
        this.$emit('updated', this.local_row);
      }
      else {
        console.error('unable to update sendout', res.status);
      }
    },

    delete_row_clicked() {
      this.delete_row();
    },
    async delete_row () {
      if (!this.local_row || !this.local_row.id) {
        return;
      } 
      
      const res = await axios.delete(`/member_renew/campaign/schedule/sendout/${local_row.id}`);

      if (res.status === 204) {
        console.log('ok');
        this.local_row = null;
        this.$emit('deleted', this.local_row.id);
      }
      else {
        console.error('unable to delete');
      }
    },

  }
}
</script>

<style scoped>
.title { margin: 0; font-size: 20px; font-weight: 600; }
.subtitle { margin-top: 4px; color: #666; }
.sendouts-list { display: grid; grid-template-columns: 1fr; gap: 16px; }
.sendout-box { border: 1px solid #e3e6ef; border-radius: 12px; padding: 12px; background: #fff; box-shadow: 0 1px 2px rgba(0,0,0,0.03); }
.sendout-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.sendout-title { display: flex; align-items: center; gap: 8px; font-weight: 600; }
.id-pill { font-size: 12px; background: #f3f4f6; color: #374151; padding: 2px 8px; border-radius: 999px; }
.sendout-actions { display: flex; gap: 8px; }
.empty { padding: 24px; text-align: center; color: #6b7280; border: 1px dashed #d1d5db; border-radius: 12px; }
.add-row { display: flex; justify-content: flex-start; }

.add-sendout-row {
  border-top: 1px solid #e5e7eb;
  padding-top: 16px;
}
.add-sendout-label {
  font-weight: 500;
  font-size: 14px;
}
.add-sendout-btn {
  display: flex;
  justify-content: flex-end;
}


</style>
